import { render, staticRenderFns } from "./borrowBook.vue?vue&type=template&id=614f41dc&"
import script from "./borrowBook.vue?vue&type=script&lang=js&"
export * from "./borrowBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports